import {Empty as AntdEmpty} from 'antd';
import * as classnames from 'classnames';
import styles from './Empty.module.scss';

const Empty = ({image = AntdEmpty.PRESENTED_IMAGE_SIMPLE, style = {marginTop: 40}, ...props}) => (
  <div>
    <AntdEmpty
      image={image}
      style={style}
      {...props}
      className={classnames({
        [styles.empty]: true,
      })}
    />
  </div>
);

export default Empty;
